<template>
  <div class="account main">
    <div class="mt20">
      <span class="title1">子账户管理</span>
    </div>
    <div class="mt20 overflow-h">
      <span class="fr purple-btn" @click="newAccount" style="position: relative;z-index: 1000;">新建子账户</span>
    </div>
    <div class="search-one">
      <div class="search-item">
        姓名
        <Input class='ml10 mr20 w200' v-model="screenData.user_name" placeholder="请输入姓名" />
        子账户编号
        <Input class='ml10 mr20 w200' v-model="screenData.client_code" placeholder="请输入子账户编号" />
        <button class="ivu-btn ivu-btn-primary fr" @click="setPage(1)">搜索</button>
      </div>
    </div>
    <section class="account-box mt20">
      <Table border :columns="columns" :data="list">
        <template slot-scope="{ row, index }" slot="notice">
          <i-switch v-model="row.is_need_notice" @on-change="change(row)"></i-switch>
        </template>
      </Table>
      <Paging v-bind:page-data="pageData" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    </section>


    <!-- 创建子账户 -->
    <Modal v-model="add_modal" :title="title" width="700">
      <div class="p20 tc">
        <div style="text-align: left;">
          子账户姓名：
        </div>
        <div style="text-align: left;">
          <Input v-model="form_data.user_name" placeholder="请输入姓名" class="w200 mt10" />
        </div>
      </div>
      <div class="p20 tc">
        <div style="text-align: left;">
          子账户类型：
        </div>
        <div class="mt10" style="text-align: left;">
          <RadioGroup v-model="form_data.code_type">
             <Radio :label="item.biz_type" v-for="(item,index) in biz_types" :key="index" border>{{biz_config[item.biz_type]}}</Radio>
            <!-- <Radio label="0" border>中转补货</Radio>
            <Radio label="1" border>移库换标</Radio>
            <Radio label="2" border>退货质检</Radio>
            <Radio label="3" border>PREP</Radio>
            <Radio label="4" border>中转发货</Radio> -->
          </RadioGroup>
        </div>

      </div>
      <div v-if="form_data.code_type!=3">
        <div class="p20 tc">
          <p class="f14 red mt10">请输入客户姓名，将随机生成一个6位数字作为客户编号</p>
        </div>
      </div>
      <div v-if="form_data.code_type==3">
        <div class="p20 tc">
          <p class="f14 red mt10">请输入客户姓名，将随机生成一个5位英文字母作为客户编号</p>
        </div>
        <div class="p20 tc">
          Amazon店铺名称： <Input v-model="form_data.store_name" placeholder="请输入店铺名称" class="w200 ml20" />
        </div>
        <div class="p20 tc">
          授权邮箱： <Input v-model="form_data.store_email" placeholder="请输入授权邮箱" class="w200 ml20" />
        </div>
      </div>
      <div slot="footer" class="tc">
        <button class="ivu-btn ivu-btn-primary" @click="submitUser">确定</button>
        <button class="ivu-btn ivu-btn-white" @click="add_modal=false">取消</button>
      </div>
    </Modal>

    <Modal v-model="update_modal" :title="update_title" width="600">
      <div class="p20 tc">
        子账户姓名： <Input v-model="form_data.user_name" placeholder="请输入姓名" class="w200 ml20" />
      </div>
      <div v-if="form_data.code_type==3">
        <div class="p20 tc">
          Amazon店铺名称： <Input v-model="form_data.store_name" placeholder="请输入店铺名称" class="w200 ml20" />
        </div>
        <div class="p20 tc">
          授权邮箱： <Input v-model="form_data.store_email" placeholder="请输入授权邮箱" class="w200 ml20" />
        </div>
      </div>
      <div slot="footer" class="tc">
        <button class="ivu-btn ivu-btn-primary" @click="updateUser">确定</button>
        <button class="ivu-btn ivu-btn-white" @click="update_modal=false">取消</button>
      </div>
    </Modal>

    <Modal v-model="check_modal" :title="check_title" width="1000">
      <div class="p5">
        如不符合以下质检条件时：
      </div>
      <div class="p5">
        <Checkbox ref="discard_item" v-model="checkItem.need_direct_discard" @on-change="onChangeCodeCheckDiscard()">
          直接废弃</Checkbox>
      </div>
      <div class="p5">
        <Checkbox v-model="checkItem.need_check_picture" @on-change="onChangeCodeCheckPicture()">上传照片</Checkbox>
      </div>
      <div class="p5">
        <Table border :columns="check_columns" :data="check_data">
        </Table>
        <Button @click="addCheckItem()">
          <Icon type="md-add" />
        </Button>
      </div>
      <div slot="footer" class="tc">
      </div>
    </Modal>

  </div>
</template>
<script>
  import Paging from "@/components/common/paging";
  export default {
    components: {
      Paging
    },
    data() {
      return {
        pageData: {
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 11 //页面最多显示几个分页组
        },
        screenData: {
          PageNum: 1,
          PageSize: 10
        },
        columns: [{
            title: "子账户姓名",
            key: "user_name",
            tooltip: true,
            width: 150,
          }, {
            title: "子账户编号",
            key: "client_code",
            tooltip: true,
            width: 140,
          }, {
            title: "子账户类型",
            key: "code_type",
            width: 140,
            render: (h, params) => {
              return h("div", this.getCodeTypeText(params.row.code_type));
            }
          }, {
            title: "Amazon店铺名称",
            key: "store_name",
            tooltip: true,
            width: 180,
          }, {
            title: "授权邮箱",
            key: "store_email",
            tooltip: true,
            width: 300,
          },
          {
            title: "SKU累计数量",
            key: "total_sku",
            width: 120,
          },
          {
            title: "商品累计数量",
            key: "total_product",
            width: 120,
          },
          {
            title: "在库SKU数量",
            key: "instock_sku",
            width: 120,
          },
          {
            title: "在库商品数量",
            key: "instock_product",
            width: 120,
          },

          {
            title: "创建时间",
            key: "create_date",
            tooltip: true,
          },
          {
            title: '操作',
            width: 200,
            fixed: 'right',
            render: (h, params) => {
              let doms = [];
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0000ff"
                },
                on: {
                  click: () => {
                    this.showUpdateUser(params.row)
                  }
                }
              }, '编辑 '));
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#aa0000"
                },
                on: {
                  click: () => {
                    this.deleteClientCode(params.row.client_code)
                  }
                }
              }, '删除 '));

              if (params.row.code_type == 2) {
                doms.push(h('span', {
                  style: {
                    cursor: "pointer",
                    color: "#0062da"
                  },
                  on: {
                    click: () => {
                      this.checkItem.need_check_picture = params.row.need_check_picture;
                      this.checkItem.need_direct_discard = params.row.need_direct_discard;
                      this.checkItem.client_code = params.row.client_code;
                      this.setCheckModal(params.row.client_code);
                    }
                  }
                }, '质检条件 '));
              }

              return h("div", doms);
            }
          }
        ],
        list: [],
        form_data: {
          user_name: "",
        },
        add_modal: false,
        update_modal: false,
        update_title: '更新子账户姓名',
        title: '创建运营ID',
        check_modal: false,
        check_title: '设置质检条件',
        checkItem: {},
        check_data: [],
        check_columns: [{
          title: "ID",
          key: "check_item_id",
          tooltip: true,
          width: 150,
        }, {
          title: "条件",
          key: "check_item",
          tooltip: true,
          render: (h, params) => {
            return h('div', {
                style: {
                  height: '100%',
                },
              },
              [h('input', {
                  style: {
                    height: '22px',
                    border: '1px solid #dcdee2',
                    display: params.row.$isEdit ? 'block' : 'none',
                  },
                  domProps: {
                    value: params.row.check_item,
                  },
                  props: {
                    value: params.row.check_item,
                  },
                  on: {
                    input: () => {
                      console.log("params.row.check_item", this.check_data, event, params.row.check_item)

                    },
                    // "change": (e) => {
                    //   console.log(e)
                    //   console.log('enter事件！');

                    //   this.check_data[params.index].$isEdit = false;
                    // },
                    "blur": () => { // 离焦事件
                      console.log('离焦事件！');

                      if (params.row.check_item_id == 0) {
                        this.saveCheckItem(event.target.value);

                      } else {
                        this.updateCheckItem(params.row.check_item_id, event.target.value);
                        this.check_data[params.index].check_item = event.target.value;
                        this.check_data[params.index].$isEdit = false;
                      }

                    }
                  }
                }),
                h('div', {
                  style: {
                    display: params.row.$isEdit ? 'none' : 'block',
                    height: '22px',
                  },
                  on: {
                    click: () => {
                      console.log('点击了字！')
                      this.check_data[params.index].$isEdit = true;
                    }
                  }
                }, params.row.check_item)
              ])
          }

        }, {
          title: "最后更新",
          key: "update_date",
          tooltip: true,
          width: 180,
        }, {
          title: "创建时间",
          key: "create_date",
          tooltip: true,
          width: 180,
        }, {
          title: "操作",
          slot: "action",
          width: 150,
          render: (h, params) => {
            return h("button", {
              on: {
                click: () => {
                  this.deleteCheckItem(params.row.check_item_id);
                }
              }
            }, "删除")
          }
        }],
        biz_types:[],
        biz_config:{ //0中转补货， 1-移库换标， 2- 退货质检， 3- PREP， 4-中转发货；
          0:'中转补货',
          1:'移库换标',
          2:'退货质检',
          3:'PREP',
          4:'中转发货',
        }
      };
    },
    methods: {
      getBiztype(){ //业务类型
        this.$axios.get("/client/biz/type").then(res => {
          this.biz_types = res.data || []
        });
      },
      getCodeTypeText(code_type) {
        switch (code_type) {
          case 0:
            return "中转补货";
          case 1:
            return "移库换标";
          case 2:
            return "退货质检";
          case 3:
            return "PREP";
          case 4:
            return "中转发货";
        }
      },
      submitUser() {
        if (!this.form_data.user_name) {
          this.$Message.info('请输入子账户姓名')
          return
        }
        if (!this.form_data.code_type&&this.form_data.code_type!=0) {
          this.$Message.info('请选择子账户类型')
          return
        }
        this.$axios.post('client/code', this.$qs.stringify({
          user_name: this.form_data.user_name,
          store_name: this.form_data.store_name,
          store_email: this.form_data.store_email,
          code_type: this.form_data.code_type
        })).then(res => {
          if (res.success) {
            this.$Message.success('创建成功')
            this.add_modal = false

            this.getList();
            //window.location.reload()
          }
        })
      },
      updateUser() {
        if (!this.form_data.user_name) {
          this.$Message.info('请输入子账户姓名')
          return
        }
        this.$axios.post('client/code/update', this.$qs.stringify({
          client_code: this.form_data.client_code,
          store_name: this.form_data.store_name,
          store_email: this.form_data.store_email,
          user_name: this.form_data.user_name
        })).then(res => {
          if (res.success) {
            this.$Message.success('更新成功')
            this.update_modal = false
            //window.location.reload()
            this.getList();
          }
        })
      },
      newAccount() { //新建账号
        this.title = "新建账号";
        this.form_data = {
          user_name: "",
        }
        this.add_modal = true;
      },
      setCheckModal(client_code) {

        this.getCheckItemList(client_code);
        this.check_modal = true;
      },
      setPage(page) {
        this.pageData.pageIndex = page;
        this.screenData.PageNum = page;
        this.getList();
      },
      chooseSize(size) {
        this.pageData.pageSize = this.screenData.PageSize = size;
        let p = Math.ceil(this.pageData.dataTotal / this.pageData.pageSize);
        if (this.pageData.pageIndex > p) {
          this.pageData.pageIndex = this.screenData.PageNum = p;
        }
        this.getList();
      },
      getList() {
        this.$axios.get("/client/code", {
          params: this.screenData
        }).then(res => {
          let arr = [];
          if (res.success && res.data && res.data.length > 0) {
            arr = res.data;
          }
          this.list = arr;
          this.pageData.pageTotal = res.pageTotal;
          this.pageData.dataTotal = res.totalSize;
        });
      },
      //删除
      deleteClientCode(client_code) {
        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要删除编号为' + client_code + '的子账户吗？如果子账户名下有在库库存，那么删除子账户的同时在库库存将被提交为废弃！且此操作不可恢复！</p>',
          onOk: () => {
            that.$axios.delete("/client/code?client_code=" + client_code).then(res => {
              if (res.success) {
                that.$Message.success(res.msg);
                that.getList()
              } else {
                that.$Message.error(res.msg);
              }
            })
          },
          onCancel: () => {

          }
        });

      },
      showUpdateUser(data) {
        this.form_data = data;
        this.update_modal = true;
      },
      getCheckItemList(client_code) {
        this.$axios.get("/client/code/check/items", {
          params: {
            client_code: client_code
          }
        }).then(res => {
          let arr = [];
          if (res.success && res.data && res.data.length > 0) {
            arr = res.data;
          }
          arr.forEach(function(item, index) {
            item.$isEdit = false;
          });
          this.check_data = arr;


        });
      },
      onChangeCodeCheckPicture() {
        this.checkItem.need_direct_discard = !this.checkItem.need_check_picture;
        this.onChangeCodeCheck();
      },
      onChangeCodeCheckDiscard() {
        this.checkItem.need_check_picture = !this.checkItem.need_direct_discard;
        this.onChangeCodeCheck();
      },
      onChangeCodeCheck() {
        this.$axios.put('client/code/check', this.$qs.stringify({
          client_code: this.checkItem.client_code,
          need_check_picture: this.checkItem.need_check_picture,
          need_direct_discard: this.checkItem.need_direct_discard
        })).then(res => {
          if (res.success) {
            //更新list里的数据
            let _this = this;
            this.list.forEach(function(item, index) {
              if (item.client_code == _this.checkItem.client_code) {
                item.need_check_picture = _this.checkItem.need_check_picture;
                item.need_direct_discard = _this.checkItem.need_direct_discard;
              }
            });

            this.$Message.success('更新成功')
          }
        })
      },
      updateCheckItem(check_item_id, check_item) {
        this.$axios.put('client/code/check/item', this.$qs.stringify({
          check_item_id: check_item_id,
          check_item: check_item
        })).then(res => {
          if (res.success) {
            //this.getCheckItemList(this.checkItem.client_code);
            this.$Message.success('更新成功');
          }
        })
      },
      addCheckItem() {
        let item = {};
        item.check_item_id = 0;
        item.$isEdit = true;
        this.check_data.push(item);
      },
      saveCheckItem(check_item) {
        this.$axios.post('client/code/check/item', this.$qs.stringify({
          client_code: this.checkItem.client_code,
          check_item: check_item
        })).then(res => {
          if (res.success) {
            this.getCheckItemList(this.checkItem.client_code);
            this.$Message.success('更新成功');
          }
        })
      },
      deleteCheckItem(check_item_id) {

        if (check_item_id == 0) {
          var index = this.check_data.findIndex(item => {
            if (item.check_item_id == check_item_id) {
              return true;
            }
          })
          this.check_data.splice(index, 1)
          return;
        }

        this.$axios.delete('client/code/check/item', {
          params: {
            check_item_id: check_item_id
          }
        }).then(res => {
          if (res.success) {
            var index = this.check_data.findIndex(item => {
              if (item.check_item_id == check_item_id) {
                return true;
              }
            });
            this.check_data.splice(index, 1);
            this.$Message.success('更新成功');
          }
        })
      }
    },
    created() {
      this.getList();
      this.getBiztype()
    }
  };
</script>
<style lang="scss">
  .new-account {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-right: 10px;
    }

    .list {
      height: 50px;
      line-height: 50px;
      // margin-bottom: 5px;
    }
  }

  .account {
    .account-box {
      margin: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/client_mgr/list.vue